document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  if (toggle && drawer) {
    toggle.addEventListener('click', () => {
      const open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    });
    drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    }));
  }

  document.querySelectorAll('[data-product-grid]').forEach((grid) => {
    const section = grid.closest('[data-featured-collection]');
    const button = section && section.querySelector('[data-load-more]');
    const step = Number(grid.dataset.step || 6);
    const initial = Number(grid.dataset.initial || 6);
    let visible = Number(grid.dataset.initial || 6);
    let activeEnergy = 'all';
    const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
    const filters = section ? Array.from(section.querySelectorAll('[data-energy-filter]')) : [];
    const update = () => {
      let matchingIndex = 0;
      cards.forEach((card) => {
        const matches = activeEnergy === 'all' || card.dataset.energy === activeEnergy;
        const shouldShow = matches && matchingIndex < visible;
        card.classList.toggle('is-hidden', !shouldShow);
        if (matches) matchingIndex += 1;
      });
      if (button) {
        const complete = visible >= matchingIndex;
        button.hidden = complete;
        button.style.display = complete ? 'none' : '';
      }
    };
    if (button) button.addEventListener('click', () => { visible += step; update(); });
    filters.forEach((filter) => {
      filter.addEventListener('click', (event) => {
        event.preventDefault();
        activeEnergy = filter.dataset.energyFilter || 'all';
        visible = initial;
        filters.forEach((item) => {
          const selected = item === filter;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        update();
      });
    });
    update();
  });

  const arcana = [
    ['0 · The Fool', 'A beginning asks for curiosity, not certainty.'],
    ['I · The Magician', 'Use what is already in your hands.'],
    ['II · The High Priestess', 'The quiet answer is still an answer.'],
    ['III · The Empress', 'Make room for beauty, care and growth.'],
    ['IV · The Emperor', 'Give your intention a clear structure.'],
    ['V · The Hierophant', 'A ritual becomes meaningful through repetition.'],
    ['VI · The Lovers', 'Choose what brings your values into alignment.'],
    ['VII · The Chariot', 'Move with purpose; let direction steady you.'],
    ['VIII · Strength', 'Softness can be the most enduring form of power.'],
    ['IX · The Hermit', 'Step inward long enough to hear yourself.'],
    ['X · Wheel of Fortune', 'Change is turning something toward you.'],
    ['XI · Justice', 'Let clarity return you to balance.'],
    ['XII · The Hanged Man', 'A new view appears when you stop forcing movement.'],
    ['XIII · Death', 'Release what is complete so something honest can begin.'],
    ['XIV · Temperance', 'Let opposites meet gently in the middle.'],
    ['XV · The Devil', 'Name the attachment and your freedom begins.'],
    ['XVI · The Tower', 'What falls away makes truth visible.'],
    ['XVII · The Star', 'Hope is a practice of returning to light.'],
    ['XVIII · The Moon', 'Trust the feeling before it becomes a fact.'],
    ['XIX · The Sun', 'Allow yourself to be seen in full brightness.'],
    ['XX · Judgement', 'Answer the version of you that is ready to rise.'],
    ['XXI · The World', 'Celebrate the cycle you have completed.']
  ];
  document.querySelectorAll('[data-draw-card]').forEach((button) => {
    button.addEventListener('click', () => {
      const result = button.parentElement.querySelector('[data-draw-result]');
      const [card, message] = arcana[Math.floor(Math.random() * arcana.length)];
      if (result) result.innerHTML = `<strong>${card}</strong><br>${message}`;
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const form = select.closest('form');
      const idInput = form && form.querySelector('input[name="id"]');
      if (idInput) idInput.value = option.value;
      const price = document.querySelector('[data-product-price]');
      if (price && option.dataset.price) {
        const regular = price.querySelector('s');
        const promotion = price.querySelector('strong');
        if (regular) regular.textContent = option.dataset.price;
        if (promotion && option.dataset.promotionPrice) promotion.textContent = option.dataset.promotionPrice;
      }
    });
  });
});
